import i18n from "src/i18n/i18n";
import { ApplicationStore } from "src/store";
import { AccountDisclaimers } from "Types/api/AccountDisclaimers";

/**
 * Get the account disclaimer based on the key supplied.
 * If the account doesn't have the disclaimer configured, we fall back to a provided translation key, OR use a standardized translation key like DisclaimerFallback.test_drive_cta
 */
export const getAccountDisclaimer = (
    state: Pick<ApplicationStore, "account">,
    disclaimerKey: keyof AccountDisclaimers,
    fallbackTranslationKey?: string,
): string => {
    return (
        state.account.account_disclaimers[disclaimerKey] ||
        i18n.t(fallbackTranslationKey || `DisclaimerFallback.${disclaimerKey}`)
    );
};
